export default (width = 24, height = 25, color = '#ffffff') => `
<svg width="${width}" height="${height}" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
    <g fill="${color}" fill-rule="nonzero">
        <path d="M9.739 18.61C4.63 18.61.472 14.453.472 9.34.472 4.232 4.631.08 9.74.08 14.846.08 19 4.231 19 9.34c.002 5.113-4.155 9.27-9.262 9.27zm0-16.864c-4.192 0-7.602 3.41-7.602 7.598 0 4.192 3.41 7.603 7.602 7.603 4.19 0 7.597-3.41 7.597-7.603 0-4.188-3.407-7.598-7.597-7.598z"/>
        <path d="M12.95 10.175a.834.834 0 0 1-.832-.835c0-1.31-1.067-2.379-2.38-2.379a.835.835 0 0 1-.832-.833c0-.46.375-.834.833-.834a4.048 4.048 0 0 1 4.044 4.045.833.833 0 0 1-.833.836zM22.934 24.743a.987.987 0 0 1-.665-.243L14.074 17c-.334-.305-.307-.781.059-1.06.37-.281.938-.258 1.275.049l8.195 7.498c.338.308.31.782-.058 1.062a1.025 1.025 0 0 1-.611.194z"/>
    </g>
</svg>
`





